import { StateInterface } from 'client/Interfaces/StateInterface'
import accounts from 'client/reducers/accounts'
import customSettings from 'client/reducers/customSettings'
import experiments from 'client/reducers/experiments'
import externalAccounts from 'client/reducers/externalAccounts'
import externalVATRates from 'client/reducers/externalVATRates'
import marketplace from 'client/reducers/marketplace'
import { Action, ReducersMapObject } from 'redux'

import banking from '../components/banking/bankingSlice'
import bankTransactions from '../components/banking/bankTransactionsSlice'
import bankWithAccounts from '../components/banking/bankWithAccountsSlice'
import company from './company'
import companySettings from './companySettings'
import config from './config'
import customers from './customer'
import documentPreview from './documentPreview'
import draft from './draft'
import draftV1 from './draftV1Reducer'
import dummyReducers from './dummyReducers'
import eInvoice from './eInvoice'
import email from './email'
import error from './error'
import estimate from './estimate'
import exchangeRate from './exchangeRate'
import expenses from './expenses'
import freeTexts from './freeTexts'
import invoice from './invoice'
import invoiceNumbers from './invoiceNumbers'
import language from './language'
import navigation from './navigation'
import ongoing from './ongoing'
import payNow from './payNowManagement'
import preview from './preview'
import products from './products'
import recurringProfile from './recurringProfile'
import recurringProfiles from './recurringProfiles'
import referrals from './referrals'
import reminders from './reminders'
import reports from './reports'
import settings from './settings'
import subscriptionManagement from './Subscription'
import token from './token'
import tracker from './tracker'
import user from './user'

const reducers: ReducersMapObject<StateInterface, Action> = {
  ...dummyReducers,
  ongoing,
  customers,
  token,
  draft,
  draftV1,
  settings,
  company,
  user,
  products,
  config,
  freeTexts,
  language,
  navigation,
  email,
  subscriptionManagement,
  invoice,
  estimate,
  exchangeRate,
  payNow,
  invoiceNumbers,
  reminders,
  preview,
  tracker,
  eInvoice,
  recurringProfile,
  recurringProfiles,
  referrals,
  companySettings,
  documentPreview,
  reports,
  error,
  bankWithAccounts,
  banking,
  bankTransactions,
  accounts,
  externalAccounts,
  marketplace,
  customSettings,
  experiments,
  expenses,
  externalVATRates,
}

export default reducers
